
















import {Component} from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';

@Component({components: {}})
export default class AnalysisNextStep extends Slide {
  get text() {
    return this.data.Texts[`analysis_nextstep`];
  }
}
